

  import { computed, ref } from 'vue'
  import moment from 'moment';
  import {FilterMatchMode, FilterOperator} from "primevue/api";
  import router from "@/router";
  import {useToast} from "primevue/usetoast";
  import {useStore} from "vuex";
  import {RegisterService} from "@/models/registerService";
  import ZaloRepository from "@/services/ZaloRepository";
  import {ListService} from "@/models/listService";
  import {useRouter} from "vue-router";
  import {HoaDonDetail} from "@/models/hoaDonDetail";

  export default {
    setup() {
      const toast = useToast();
      const store = useStore();
      const list = ref([] as HoaDonDetail[]);
      const listTemp = ref([] as HoaDonDetail[]);
      const date = ref();
      const service = ref("");
      const router = useRouter();
      const kind = ref(0);

      if(!(!!store.state.token)){
        router.push({
          name: 'home'
        });
      }

      const selectCalendar = () => {
        if((date.value[0] != null)&&(date.value[1] != null))
        {
          listTemp.value = [];
          list.value = [];
          ZaloRepository.getListHoaDonDetail(date.value[0]/1000, date.value[1]/1000)
              .then((response) => {
                listTemp.value = list.value = response.data;
              })
              .catch(err => {
                toast.add({
                  severity: 'error',
                  summary: 'Lỗi',
                  detail:err.response.data,
                  life: 2500
                })})
        }
      };

      //selectCalendar();

      const clearCalendar = () => {
        list.value = [];
        listTemp.value = [];
      }

      const formatDateTime = (date) => {
        if((date == null)||(date == ''))
        {
          return "chưa có thông tin"
        }
        else
        return moment(String(date)).format(' HH:mm DD/MM/YYYY');
      };


      const clearDate = () => {
        console.log("@@@@@@@@@################ clearDate");
        if(date.value != null)
        date.value = ref();
      }

      const formatCurrency = (money) => {
        // Use Intl.NumberFormat to format the number as currency
        const formatter = new Intl.NumberFormat('vi-VN', {
          style: 'currency',
          currency: 'VND',
          minimumFractionDigits: 0, // Set the number of decimal places you want
        });
        return formatter.format(money);
      };

      return {
        formatDateTime,
        list,
        date,
        selectCalendar,
        clearCalendar,
        service,
        kind,
        clearDate,
        formatCurrency
      }
    }

  }
